export default __webpack_public_path__ + "static/media/openasea.b096bcfa.PNG";